<template>
    <div class="opened-wrap">
        <div class="section-top">
            <div class="header">
                <div class="header-left" @click="goBack">
                    <img src="@/assets/public/icon_back.png" alt="">
                </div>
                <div class="header-main">VIP课程</div>
                <div class="header-right" @click="pushCusService">
                    <img src="@/assets/vipGoods/opened/icon_ddh.png" alt="">
                </div>
            </div>
            <div class="user-wrap">
                <img class="bg" src="@/assets/vipGoods/opened/picture_vipkcbj01.png" alt="">
                <img class="bg-2" src="@/assets/vipGoods/opened/icon_viptb.png" alt="">
                <img class="bg-3" v-if="appType === 1 || version >= '3.0.0'" @click="goMisCourse" src="@/assets/vipGoods/opened/icon_wdjhk.png" alt="">
                <div class="user-top">
                    <div class="photo">
                        <img v-if="userInfo.logoUrl" :src="userInfo.logoUrl" alt=""/>
                        <img v-else src="@/assets/public/default-user-img.png" alt=""/>
                    </div>
                    <div class="name-or-info">
                        <div class="name">{{ userInfo.petName }}</div>
                        <div class="info">
                            <img v-if="pageDto.generalVipDto" src="@/assets/vipGoods/opened/icon_cjvip.png" alt="">
                            <template  v-if="pageDto.anyoneVipDto">
                                <img v-if="pageDto.anyoneVipDto.subjectOne && pageDto.anyoneVipDto.subjectOne.anyOpendFlag" src="@/assets/vipGoods/opened/icon_kyvip.png" alt="">
                                <img v-if="pageDto.anyoneVipDto.subjectTwo && pageDto.anyoneVipDto.subjectTwo.anyOpendFlag" src="@/assets/vipGoods/opened/icon_kevip.png" alt="">
                                <img v-if="pageDto.anyoneVipDto.subjectThree && pageDto.anyoneVipDto.subjectThree.anyOpendFlag" src="@/assets/vipGoods/opened/icon_ksvip.png" alt="">
                                <img v-if="pageDto.anyoneVipDto.subjectFour && pageDto.anyoneVipDto.subjectFour.anyOpendFlag" src="@/assets/vipGoods/opened/icon_kmsvip.png" alt="">
                            </template>

                        </div>
                    </div>
                </div>
                <div class="user-item">
                    <template v-for="(v,i) in subjectItem" >
                        <div :class="['item subject-item',i === subject && 'select', v.data.anyOpendFlag && 'active']" :key="i" @click="changeSubject(i)" v-if="v.data">
                            <div class="name">{{ v.name }}</div>
                            <div class="time" v-if=" v.data.anyOpendFlag">有效期至{{ v.data.validTime }}</div>
                            <div class="money" v-else>{{ v.data.subSonSettingDto.payConPrice }}元开通</div>
                        </div>
                    </template>
                </div>

            </div>
        </div>
        <div class="content">
            <template v-if="subjectItem[subject].data.allBuy">
                <div class="content-item" v-if="[0,3].includes(subject)">
                    <div class="title">{{ subject === 0 ? '科一' : '科四' }}VIP权益</div>
                    <div class="open-icon-wrap">
                        <div class="item" @click="goFnModular('pushFeaturedPage')"><img src="@/assets/vipGoods/opened/icon_jx500.png" alt=""><div>精选500道题</div></div>
                        <div class="item" @click="goFnModular('pushErrorProneStrengthenPage')"><img src="@/assets/vipGoods/opened/icon_yctgg.png" alt=""><div>易错题巩固</div></div>
                        <div class="item" @click="goFnModular('pushKnowledgeShorthandPage')"><img src="@/assets/vipGoods/opened/icon_zsdsj.png" alt=""><div>知识点速记</div></div>
                        <div class="item" @click="goFnModular('pushExamBreakthroughPage')"><img src="@/assets/vipGoods/opened/icon_kqtj.png" alt=""><div>考前突击</div></div>
                        <div class="item" @click="goFnModular('pushExamSecretPage')"><img src="@/assets/vipGoods/opened/icon_kqmj.png" alt=""><div>考前秘卷</div></div>
                        <div class="item" @click="goFnModular('pushExamIntelligentPage')"><img src="@/assets/vipGoods/opened/icon_znks.png" alt=""><div>智能考试</div></div>
                        <div class="item" @click="goFnModular('pushExamPassRatePage')"><img src="@/assets/vipGoods/opened/icon_yctgl.png" alt=""><div>预测通过率</div></div>
                        <div class="item" @click="goFnModular('pushExamRealisticPage')"><img src="@/assets/vipGoods/opened/icon_kcmn.png" alt=""><div>考场模拟</div></div>
                        <div class="item" v-if="appType === 1 || version >= '3.0.0'" @click="goFnModular('pushListenQuestionPage')"><img src="@/assets/vipGoods/opened/icon_lrtt.png" alt=""><div>懒人听题</div></div>
                    </div>
                </div>
                <div class="content-item" v-if="[0,3].includes(subject) && subjectItem[subject].ensureFlag">
                    <div class="ensure-title">
                        <div class="s1">过考保障</div>
                        <template v-if="!subjectItem[subject].perfectInfoFlag">
                            <div class="s2">您尚未完善个人信息</div>
                            <div class="s3" @click="goPerfectInfo">去填写</div>
                        </template>
                    </div>

                    <div :class="['ensure-wrap', subjectItem[subject].ensureActiveFlag === 1 && 'active', subjectItem[subject].ensureActiveFlag === 2 && 'expire']">
                        <div class="name">{{ subject === 0 ? '科一' : '科四' }}过考保障</div>
                        <div class="info">
                            <p>考试不过可补偿50元</p>
                            <div class="ensure-submit" v-if="subjectItem[subject].data.ensureActiveFlag === 0" @click="goCard">去激活</div>
                            <div class="ensure-submit" v-if="subjectItem[subject].data.ensureActiveFlag === 1" @click="goCard">申请补偿</div>
                            <div class="ensure-submit record" v-if="subjectItem[subject].data.ensureActiveFlag === 2" @click="goCard">补偿记录</div>
                        </div>
                    </div>
                </div>
                <div class="content-item" v-if="[1,2].includes(subject)">
                    <div class="title">{{subject === 1 ? '科二' : '科三'}}VIP权益</div>
                    <div class="open-icon-wrap">
                        <template v-if="subjectItem[subject].data.subSonProductDtoList">
                            <div class="item" v-for="(v,i) in subjectItem[subject].data.subSonProductDtoList" :key="i" @click="goFnModular(notOpenSub[v.goodsCode].fnName,v.goodsCode)"><img v-if="notOpenSub[v.goodsCode]" :src="notOpenSub[v.goodsCode].img" alt=""><div>{{ notOpenSub[v.goodsCode].goodsName }}</div></div>
                        </template>
                        <template v-else>
                            <div class="item" v-for="(v,i) in subjectItem[subject].data.goodsArr" :key="i" @click="goFnModular(notOpenSub[v].fnName,v)"><img v-if="notOpenSub[v]" :src="notOpenSub[v].img" alt=""><div>{{ notOpenSub[v].goodsName }}</div></div>
                        </template>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="not-open-item" v-if="[0,3].includes(subject)">
                    <div class="not-open-item-title">
                        {{ subject === 0 ? '科一' : '科四' }}VIP
                    </div>
                    <img class="product" src="@/assets/vipGoods/opened/picture_ksdyb.png" alt="">
                    <img class="product" src="@/assets/vipGoods/opened/picture_kydeb.png" alt="">
                    <img class="product" src="@/assets/vipGoods/opened/picture_kydsb.png" alt="">
                </div>

                <div class="not-open-item" v-if="[1,2].includes(subject)">
                    <div class="not-open-item-title">
                        {{ subject === 1 ? '科二' : '科三' }}VIP
                    </div>
                    <div :class="['item',v.validTime && 'active']" v-for="(v,i) in subjectItem[subject].data.subSonProductDtoList" :key="i">
                        <div class="item-left">
                            <img v-if="notOpenSub[v.goodsCode]" :src="notOpenSub[v.goodsCode].img" alt="">
                        </div>
                        <div class="item-main">
                            <p class="s1">{{ v.goodsName }}</p>
                            <p class="s2" v-if="notOpenSub[v.goodsCode]">{{ v.validTime ? `有效期至${v.validTime}` : notOpenSub[v.goodsCode].text}}</p>
                        </div>
                        <div class="item-right" v-if="v.validTime" @click="goFnModular(notOpenSub[v.goodsCode].fnName,v.goodsCode)">去学习</div>
                        <div class="item-right" v-else @click="goOpen(v.goodsCode)">去开通</div>
                    </div>
                </div>
            </template>

            <div class="content-item" v-if="[0,3].includes(subject)">
                <img class="rule-title" src="~@/assets/vipGoods/opened/icon_fwsm.png" alt="">
                <p class="rule" v-if="subjectItem[subject].ensureFlag">
                    1、感谢您购买了VIP课程，购买后即刻生效。<br/>
                    2、保障卡为VIP权益，激活后有效期至VIP课程失效日，VIP课程失效后无法申请补偿。如：2021年8月11日开通VIP课程（含过考保障），则VIP课程和保障卡有效期至2022年8月10日。<br/>
                    3、VIP课程为虚拟商品，购买后不支持退款。<br/>
                    4、为确保您过考保障的权益，开通VIP课程后，请在考试前一天激活保障卡，考试之前未激活则不能申请补偿。<br/>
                    5、一个身份证单科目只能获得一次补偿，请您及时填写个人信息，并确保姓名和身份证号码填写正确（只能填写一次，不得修改），如您的信息与考生信息不符，无法正常申请补偿。<br/>
                    6、审核时间：补偿申请提交后5-7个工作日内完成审核，打款将会发放至填写的账户信息，请确保账户为本人所有。<br/>
                    7、如有疑问，可联系斑斑客服。</p>
                <p class="rule" v-else>
                    1、感谢您购买了VIP课程，购买后即刻生效。<br/>
                    2、VIP课程为虚拟商品，购买后不支持退款。<br/>
                    3、如有疑问，可联系斑斑客服。</p>
            </div>
        </div>

        <template v-if="!subjectItem[subject].data.anyOpendFlag && !loading">
            <div class="mamber-tips">
                <div class="mamber-info">开通前请阅读<span class="tutorial" @click="handleOpenMember">《会员协议》</span></div>
                <div class="tutorial" v-if="IOS" @click="goTutorial()">iPhone支付教程</div>
            </div>
            <div class="footer">
                <div :class="['submit', disabled && 'disabled']" @click="submit()">
                    <div class="price">
                        <template v-if="cGoodsDto.payConPrice">
                            <span  class="t1">￥{{ cGoodsDto.payConPrice }}{{ cGoodsDto.effectiveDays | unit }}</span><span class="t2">原价¥{{ cGoodsDto.payOrigPrice }}</span>
                        </template>
                        <template v-else>
                            <span  class="t1">￥{{ subjectItem[subject].data.subSonSettingDto.payConPrice }}{{ subjectItem[subject].data.subSonSettingDto.effectiveDays | unit }}</span><span class="t2">原价¥{{ subjectItem[subject].data.subSonSettingDto.payOrigPrice }}</span>
                        </template>
                    </div>
                </div>
            </div>
            <c-exam-room v-if="examRoomVisible" :cityCode="cityCode" :goodsCode="goodsCode" ref="c-examRoom" @submit="(s)=>{submit(s)}" type="popup"/>
        </template>

        <van-popup round  v-model="submitVisible" position="bottom" class="submit-popup">
          <div class="popup-title">VIP开通助力驾考 <img src="@/assets/public/icon_gb.png" alt="" @click="submitVisible=false"></div>
          <div class="footer-item-menu" v-if="switchGoods.length > 1">
            <div :class="['footer-item-menu-content',v.goodsCode === cGoodsDto.goodsCode && 'active']" v-for="(v,i) in switchGoods" :key="i" @click="goodsSwitch(v)" >
              <div class="title">{{ v.goodsName }}</div>
              <div class="price">¥<b>{{ v.payConPrice }}</b>{{ v.effectiveDays | unit }}</div>
              <div class="right-top-icon" v-if="v.warnTips">{{ v.warnTips }}</div>
            </div>
          </div>
          <div class="footer-img">
            <img :src="cGoodsDto.introducePicUrl" alt="">
          </div>
          <div class="pay-item" v-if="!IOS" @click="payPopupVisible = true;submitVisible = false">
            <div class="item" v-if="payType === 2">使用 <img src="@/assets/public/icon_wx01.png" alt="">微信，更换支付方式></div>
            <div class="item" v-if="payType === 1">使用 <img src="@/assets/public/icon_zfb01.png" alt="">支付宝，更换支付方式></div>
          </div>
          <div class="pre"></div>
        </van-popup>

        <van-popup :close-on-click-overlay="false" round  v-model="payPopupVisible" position="bottom" class="pay-popup">
          <div class="popup-title">选择支付方式 <img src="@/assets/public/icon_gb.png" alt="" @click="submitVisible=true;payPopupVisible=false"></div>
          <div :class="['wx-item',payType === 2 && 'active']" @click="selectPay(2)">微信支付</div>
          <div class="hr"></div>
          <div :class="['zfb-item',payType === 1 && 'active']"  @click="selectPay(1)">支付宝</div>
        </van-popup>

        <!--消息弹出框-->
        <ctl-dialog v-model="messageDialog" :loading="dialogLoading"/>
    </div>
</template>

<script>
import { Popup, Toast } from 'vant'
import cExamRoom from './components/cExamRoom'
import ctlDialog from '@/components/dialog/index.vue'
export default {
    data () {
        return {
            userInfo: {},
            pageDto: {},
            appType: '',
            version: '',
            goodsCode: '',
            payType: 2,
            cGoodsDto: {},
            switchGoods: [],
            examPlaceBatchId: '',
            submitVisible: false,
            examRoomVisible: false,
            payPopupVisible: false,
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            notOpenSub: {
                '101': {
                    fnName: 'pushTeachVideo',
                    text: '看视频，点位技巧要牢记',
                    goodsName: '教学视频',
                    img: require('@/assets/vipGoods/opened/icon_jxspke.png')
                },
                '103': {
                    fnName: 'pushExamExplanationSubject2',
                    text: '看视频，全项扣分不能错',
                    goodsName: '考场讲解',
                    img: require('@/assets/vipGoods/opened/icon_kcjj.png')
                },
                '104': {
                    fnName: 'pushTeachVideo',
                    text: '看视频，技巧考点要牢记',
                    goodsName: '教学视频',
                    img: require('@/assets/vipGoods/opened/icon_jxspke.png')
                },
                '105': {
                    fnName: 'pushExamVideo',
                    text: '真实考场视频讲解',
                    goodsName: '考场视频',
                    img: require('@/assets/vipGoods/opened/icon_kcsp.png')
                },
                '106': {
                    fnName: 'pushLightingRealisticPage',
                    text: '考点灯光真实模拟',
                    goodsName: '灯光模拟',
                    img: require('@/assets/vipGoods/opened/icon_dgmn.png')
                }
            },
            subjectItem: [
                {
                    name: '科一VIP',
                    key: 'subjectOne',
                    data: {
                        subSonSettingDto: {}
                    }
                },
                {
                    name: '科二VIP',
                    key: 'subjectTwo',
                    data: {
                        subSonSettingDto: {}
                    }
                },
                {
                    name: '科三VIP',
                    key: 'subjectThree',
                    data: {
                        subSonSettingDto: {}
                    }
                },
                {
                    name: '科四VIP',
                    key: 'subjectFour',
                    data: {
                        subSonSettingDto: {}
                    }
                }
            ],
            disabled: false,
            loading: false,
            dialogLoading: false,
            subject: 0,
            cityCode: ''
        }
    },
    components: {
        ctlDialog,
        [Popup.name]: Popup,
        cExamRoom
    },
    methods: {
        changeSubject (v) {
            this.subject = v
            this.cGoodsDto = {}
        },
        selectPay (v) {
            this.payType = v
            this.payPopupVisible = false
            this.submitVisible = true
        },
        // 转换商品
        goodsSwitch (v) {
            // 防重复点击
            if (this.cGoodsDto.goodsCode === v.goodsCode) {
                return
            }
            Toast.loading({ duration: 0, overlay: true, message: '加载中...' })
            let postData = {
                goodsCode: v.goodsCode
            }
            this.$api.switchGoods(postData).then(res => {
                setTimeout(() => {
                    Toast.clear()
                }, 500)
                if (res.status) {
                    this.goodsCode = v.goodsCode
                    this.cGoodsDto = res.result.settingDto
                    this.pageDto.noneOpendSonSelectedDto = res.result
                    if (this.pageDto.noneOpendSonSelectedDto.containGoodsCode) {
                        this.examRoomVisible = this.pageDto.noneOpendSonSelectedDto.containGoodsCode.includes('105')
                    } else {
                        this.examRoomVisible = false
                    }
                } else {
                    Toast(res.message)
                }
            })
        },
        // 跳转详情
        goDetail (v) {
            localStorage.setItem('openVipGoodsSubject', this.subject)
            if (v.orderType === 2) {
                this.$router.push({
                    name: 'goodsOrderDetail',
                    query: { id: v.id, headShow: '1', goodsCode: this.goodsCode, sourceType: this.appType === 100 ? '2' : '1' }
                })
            } else if (v.orderType === 4) {
                this.$router.push({
                    name: 'teachVideoOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 6) {
                this.$router.push({
                    name: 'peijiaOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 7) {
                this.$router.push({
                    name: 'ensureOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 8) {
                this.$router.push({
                    name: 'vipPackageOderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 9) { // 跳转到灯光仿真的订单详情页
                this.$router.push({
                    name: 'goodsLightOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 10) { // 跳转到微课的订单详情页
                this.$router.push({
                    name: 'microCourseOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 11) { // 跳转到模拟机的订单详情页
                this.$router.push({
                    name: 'simulationOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 12) { // 跳转到计时卡的订单详情页
                this.$router.push({
                    name: 'timeAppPayOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 13) { // 跳转到微课订单详情页
                this.$router.push({
                    name: 'welfareOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 14) { // 跳转到vip商品订单详情页
                this.$router.push({
                    name: 'vipGoodsOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else {
                this.$router.push({
                    name: 'vipOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            }
        },
        // 获取vip数据
        getData () {
            let postData = {
                cityCode: this.cityCode,
                entryType: '2',
                subject: this.subject,
                goodsCode: this.subjectItem[this.subject].data.subSonSettingDto.goodsCode
            }
            postData.examPlaceBatchId = this.$route.query.examPlaceBatchId || ''

            // 判断是否有指定商品
            Toast.loading({ duration: 0, overlay: true, message: '加载中...' })
            this.$api.fixedGoodsEntry(postData).then(res => {
                Toast.clear()

                if (res.status) {
                    // 默认选择第一个商品
                    this.cGoodsDto = res.result.noneOpendDto.noneOpendSonSelectedDto.settingDto
                    this.goodsCode = res.result.noneOpendDto.noneOpendSonSelectedDto.settingDto.goodsCode
                    this.switchGoods = []
                    // 搭配商品选项
                    if (res.result.noneOpendDto.noneOpendSonHookDtoList) {
                        this.switchGoods = [res.result.noneOpendDto.noneOpendSonSelectedDto.settingDto, ...res.result.noneOpendDto.noneOpendSonHookDtoList]
                    }
                    if (res.result.noneOpendDto.noneOpendSonSelectedDto.containGoodsCode) {
                        this.examRoomVisible = res.result.noneOpendDto.noneOpendSonSelectedDto.containGoodsCode.includes('105')
                    } else {
                        this.examRoomVisible = false
                    }

                    this.submitVisible = true
                }
            })
        },
        // 立即开通
        submit (v) {
            if (this.disabled || this.messageDialog.visible) {
                return
            }

            if (!this.submitVisible && !v) {
                this.getData()
                return
            }

            // 考场组件选择判断
            if (this.$refs['c-examRoom'] && !v) {
                if (this.$refs['c-examRoom'].examVisible) {
                    this.submitVisible = false
                    this.$refs['c-examRoom'].examRoomVisible = true
                } else {
                    Toast('当前选中的城市没有考场视频！')
                }
                return
            }
            this.examPlaceBatchId = v

            // 请求数据
            let postData = {
                currentUserId: this.userInfo.currentUserId,
                cityCode: this.cityCode,
                goodsCode: this.goodsCode,
                examPlaceBatchId: this.examPlaceBatchId
            }

            this.loading = true
            this.$api.vipGoodsPay(postData).then(res => {
                this.loading = false
                this.submitVisible = false
                // 正常支付流程
                if (res.code === '200' && res.status) {
                    // 判断是否IOS && 苹果支付
                    if (this.IOS) {
                        // 唤起支付
                        this.$jsBridge.callBackHandler('applyPay', {
                            orderId: res.result,
                            productId: this.subjectItem[this.subject].data.subSonSettingDto.productId,
                            goodsCode: this.goodsCode
                        })
                        return
                    }

                    localStorage.setItem('openVipGoodsSubject', this.subject)

                    // 唤起支付
                    this.$jsBridge.callBackHandler('pay', { orderId: res.result, payWay: this.payType, goodsCode: this.goodsCode || '' })
                }

                // 错误状态码处理
                if (res.code === '701') {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去支付',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                            this.goDetail({
                                id: res.result.split('-')[0],
                                orderType: Number(res.result.split('-')[1])
                            })
                        },
                        title: '',
                        content: '您有VIP商品订单未支付'
                    }
                }
            })
        },
        // 获取页面数据
        getPageData () {
            let postData = {
                cityCode: this.cityCode,
                subject: this.subject,
                entryType: '2',
                goodsCode: this.goodsCode
            }
            Toast.loading({ duration: 0, overlay: true, message: '加载中...' })
            let apiName = this.goodsCode ? this.$api.fixedGoodsEntry : this.$api.unfixedGoodsEntry
            this.loading = true

            apiName(postData).then(res => {
                Toast.clear()
                this.loading = false

                if (res.status) {
                    this.pageDto = res.result

                    this.subjectItem.forEach((v, i) => {
                        if (res.result.generalVipDto) {
                            v.data = {
                                ...res.result.generalVipDto,
                                goodsArr: res.result.generalVipDto[`${v.key}Goods`],
                                anyOpendFlag: true,
                                ensureFlag: res.result.generalVipDto['ensureFlag' + (i + 1)],
                                ensureActiveFlag: res.result.generalVipDto['ensureActiveFlag' + (i + 1)],
                                allBuy: true,
                                perfectInfoFlag: res.result.generalVipDto['perfectInfoFlag' + (i + 1)]
                            }
                            this.subject = v.data.defaultSubject - 1
                        } else {
                            v.data = res.result.anyoneVipDto[v.key]
                            if (v.data) {
                                v.data.allBuy = true

                                if (v.data.isSelected) {
                                    this.subject = i
                                }
                                // 遍历子商品
                                res.result.anyoneVipDto[v.key].subSonProductDtoList.find(vv => {
                                    if (!vv.validTime) {
                                        v.data.allBuy = false
                                    }
                                })
                            }
                        }
                        if (['subjectTwo', 'subjectThree'].includes(v.key) && this.appType === 2 && this.version < '3.0.0') {
                            v.data = ''
                        }
                        // 记忆上一次操作
                        if (localStorage.getItem('openVipGoodsSubject')) {
                            this.subject = Number(localStorage.getItem('openVipGoodsSubject'))
                            localStorage.removeItem('openVipGoodsSubject')
                        }
                        this.$nextTick(() => {
                            document.querySelectorAll('.user-item')[0].scrollLeft = document.querySelectorAll('.subject-item')[this.subject].offsetLeft + -10
                        })
                    })
                } else {
                    Toast(res.message)
                }
            })
        },
        // 检查车型
        checkCarType () {
            const carTypeName = this.$store.getters.carTypeName

            if (Number(this.carType) !== 1) {
                this.messageDialog = {
                    visible: true,
                    rightBtnName: '切换题库',
                    leftBtnName: '我知道了',
                    leftBtnMethod: () => {
                        this.messageDialog.visible = false
                    },
                    rightBtnMethod: () => {
                        this.messageDialog.visible = false

                        this.$jsBridge.callBackHandler('pushQuestionBankSettingPage')
                    },
                    title: '温馨提示',
                    content: `该服务现仅适用于小车学员，您当前车型-${carTypeName[this.carType]}，是否需切换回小车题库？`
                }
            }
        },
        // 刷新数据
        refreshCallBack () {
            // 重新设置车型
            this.carType = Number(this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || 1))

            this.disabled = this.carType !== 1

            // 重新获取app用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            // 重新获取app token
            let ctlToken = this.$jsBridge.callBackHandler('passTokenData')

            if (ctlToken) {
                localStorage.setItem('ctl-token', JSON.parse(ctlToken).token)
            }

            // 重新设置城市code
            this.cityCode = this.$route.query.cityCode || this.$jsBridge.callBackHandler('passRegionCodeData')

            this.getPageData()
            // 检查车型
            this.checkCarType()

            this.key++
        },
        // 返回
        goBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        },
        // 跳转支付教程
        goTutorial () {
            localStorage.setItem('openVipGoodsSubject', this.subject)

            this.$router.push({ name: 'vipGoodsTutorial' })
        },
        // 跳转精华科
        goMisCourse () {
            // 未登录不能使用
            if (!this.userInfo.userId) {
                this.$jsBridge.callBackHandler('loginUserV2')
                return
            }
            localStorage.setItem('openVipGoodsSubject', this.subject)

            this.$router.push({ name: 'microCourseMy' })
        },
        // 跳转开通
        goOpen (v) {
            let query = this.$route.query
            query.id = v

            localStorage.setItem('openVipGoodsSubject', this.subject)

            this.$router.push({ name: 'vipGoods', query: { ...query, back: '1' } })
        },
        // 跳转理论保障卡
        goCard () {
            localStorage.setItem('openVipGoodsSubject', this.subject)

            this.$router.push({ name: 'ensureCard', query: { vipUserId: this.subjectItem[this.subject].data.vipUserId } })
        },

        // 跳转完善个人信息
        goPerfectInfo () {
            localStorage.setItem('openVipGoodsSubject', this.subject)

            this.$router.push({ name: 'ensurePerfectInfo', query: { vipUserId: this.subjectItem[this.subject].data.vipUserId } })
        },
        // 在线客服
        pushCusService () {
            this.$jsBridge.callBackHandler('pushCusService')
        },
        // 支付回调
        payCallback (v) {
            // 开通成功
            if (String(v) === '1') {
                this.$jsBridge.callBackHandler('openSuccess', { goodsCode: this.goodsCode })
            }
        },
        // 跳转功能
        goFnModular (v, code) {
            // H5标记不能进入
            if (this.H5) {
                this.linkApp()
                return
            }

            // 未登录不能使用
            if (!this.userInfo.userId) {
                this.$jsBridge.callBackHandler('loginUserV2')
                return
            }

            localStorage.setItem('openVipGoodsSubject', this.subject)

            // 特殊处理
            if (v === 'pushExamVideo') {
                this.$router.push({ name: 'vipGoodsExamCategory', query: { ...this.$route.query } })
                return
            }

            if (['pushTeachVideo', 'pushExamExplanationSubject2'].includes(v)) {
                Toast.loading({ duration: 0, overlay: true, message: '加载中...' })
                this.$api.getSingleGoodsAssociatedWithContentId({ goodsCode: code }).then(res => {
                    Toast.clear()
                    if (res.status) {
                        this.$jsBridge.callBackHandler(v, { subject: this.subject + 1, id: res.result })
                    } else {
                        Toast(res.message)
                    }
                })
                return
            }

            // 跳转功能
            this.$jsBridge.callBackHandler(v, { subject: this.subject + 1 })
        },
        // 打开会员开通协议页面
        handleOpenMember () {
            this.$jsBridge.callBackHandler('pushSecondaryPage', {
                secondaryUrl: `${window.location.origin}/ui/h5/agreement/memberPartyInfo`
            })
        }
    },
    created () {
        // 设置版本号
        this.version = this.$jsBridge.callBackHandler('getAppVersion') || ''

        // 暴露支付回调方法
        this.$jsBridge.registerHandler('payCallback', this.payCallback)
        let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

        this.userInfo = userInfo ? JSON.parse(userInfo) : {}
        this.subject = this.$route.query.subject
        if (String(this.subject) === '5') {
            this.subject = '4'
        }
        if (String(this.subject) === '0') {
            this.subject = '1'
        }
        this.carType = Number(this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || 1))
        this.appType = Number(this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType))

        // 暴露支付回调方法
        this.$jsBridge.registerHandler('payCallback', this.payCallback)

        this.disabled = this.carType !== 1

        this.goodsCode = this.$route.query.id
        this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || this.$route.query.cityCode

        this.$jsBridge.registerHandler('refreshCallBack', this.refreshCallBack)
    },
    mounted () {
        this.getPageData()
        this.checkCarType()
    }
}
</script>

<style scoped lang="scss">
  .footer{
    position: static;
    z-index: 99999;
    background: #ffffff;
    padding: 5px 0;

    .submit{
        position: relative;
        margin: 0 auto;
        width: 355px;
        height: 60px;
        background: url("~@/assets/vipGoods/ljkt.gif") no-repeat 100%/100%;
        .price{
            margin: 0 0 0 20px;
            position: absolute;
            transform: translateY(-50%);
            top: 50%;
        }
        .price .t1{
            font-size: 24px;
            font-weight: 600;
            color: #FFFFFF;
        }
        .price .t2{
            font-size: 15px;
            color: rgba(255, 255, 255, 0.6);
            margin: 0 0 0 5px;
            text-decoration: line-through;
        }
    }

    .submit.disabled{
        background: url("~@/assets/vipGoods/icon_dban_zh.png") no-repeat 100%/100%;
    }
}
.tutorial{
    text-align: right;
    text-decoration: underline;
    font-size: 13px;
    color: #A6431B;
}
.opened-wrap{
    display: flex;
    height: 100%;
    flex-direction: column;
    background: #F3F4F5;
    .section-top{
        overflow: hidden;
        background: url("~@/assets/vipGoods/opened/picture_vipkcbj.png") no-repeat top/100% 100%;
        .header{
            padding: 13px 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .header-left,.header-right{
            width: 24px;
            font-size: 0;
            img{
                width: 24px;
            }
        }
        .header-main{
            font-size: 18px;
            font-weight: 600;
            color: #333333;
        }
        .user-wrap{
            position: relative;
            .bg{
                width: 100%;
                display: block;
            }
            .bg-2{
                width: 91px;
                right: 0;
                top: 0;
                position: absolute;
            }
            .bg-3{
                width: 90px;
                right: 5px;
                top: 60px;
                position: absolute;
            }
            .user-top{
                margin: 25px 0 0 20px;
                top: 0;
                position: absolute;
                display: flex;
            }
            .user-top .photo{
                img{
                    width: 60px;
                    height: 60px;
                    overflow: hidden;
                    border-radius: 50%;
                    display: block;
                    object-fit: cover;
                }
            }
            .user-top .name-or-info{
                margin: 0 0 0 10px;
                flex: 1;
                .name{
                    margin: 7px 0 0 0;
                    font-size: 18px;
                    font-weight: 600;
                    color: #000000;
                }
                .info img{
                    margin: 10px 0 0 0;
                    width: 42px;
                }
                .info img+img{
                   margin: 0 0 0 5px;
                }
            }
            .user-item{
                position: absolute;
                top: 100px;
                display: flex;
                align-items: center;
                width: 355px;
                margin: 0 0 0 10px;
                overflow: auto;
                -webkit-overflow-scrolling: touch;
                flex-wrap: nowrap;
                &::-webkit-scrollbar {
                    display: none;
                }
                .item{
                    overflow: hidden;
                    position: relative;
                    box-sizing: border-box;
                    margin: 0 0 0 10px;
                    flex: 0 0 197px;
                    height: 100px;
                    border-radius: 5px;
                    background: url("~@/assets/vipGoods/opened/icon_vipkpbj.png") no-repeat center/100%;
                }
                .item .name{
                    line-height: 1;
                    margin: 10px;
                    font-size: 18px;
                    font-weight: 600;
                    color: #000000;
                }
                .item .time{
                    line-height: 1;
                    margin: 10px 0 0 10px;
                    font-size: 13px;
                    color: #000000;
                }
                .select{
                    border: 2px solid #FF0000;
                    .name{
                        color: #FF0000;
                    }
                }
                .item::after{
                    position: absolute;
                    right: -1px;
                    top: -1px;
                    content: ' ';
                    width: 50px;
                    height: 18px;
                    background: url("~@/assets/vipGoods/opened/icon_wktbq01.png") no-repeat left/100%;
                }
                .active::after{
                    background: url("~@/assets/vipGoods/opened/icon_yktbq.png") no-repeat left/100%;
                }
                .money{
                    position: absolute;
                    left: 50%;
                    bottom: 15px;
                    transform: translateX(-50%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 90px;
                    height: 24px;
                    background: #FFE584;
                    border-radius: 12px;
                    font-size: 15px;
                    font-weight: 600;
                    color: #FF0000;
                }
            }
        }
    }
    .content{
        scroll-padding-block:10px 0;
        flex: 1;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        width: 375px;
        background: #F3F4F5;
        border-radius: 10px 10px 0 0;
        position: relative;
        margin: -8px 0 0 0;
        &::before{
            content: ' ';
            display: block;
            position: sticky;
            background: #F3F4F5;
            height: 10px;
            width: 100%;
            top: 0;
            z-index: 9;
        }
        .not-open-item{
            padding: 10px 10px 0;
            margin: 0 0 10px 0;
            .not-open-item-title{
                padding: 0 0 5px 0;
                line-height: 1;
                font-size: 18px;
                font-weight: 600;
                color: #000000;
            }
            .product{
                width: 355px;
                margin: 10px 0 0 0;
            }
            .item{
                position: relative;
                margin: 10px 0 0 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
                line-height: 1;
                width: 355px;
                height: 90px;
                background: #FFFFFF;
                border-radius: 5px;
                box-sizing: border-box;
                padding: 26px 10px;
                &::before{
                    position: absolute;
                    top: -1px;
                    left: -1px;
                    content: ' ';
                    background: url("~@/assets/vipGoods/opened/icon_wktbq.png") no-repeat left/100%;
                    width: 50px;
                    height: 18px;
                }
            }
            .active{
                &::before{
                    background: url("~@/assets/vipGoods/opened/icon_yktbq01.png") no-repeat left/100%;
                }
                .item-right{
                    background: #ffffff;
                    border: 1px solid #FF5E03;
                    color: #FF5E03;
                }
            }
            .item-left{
                img{
                    width: 38px;
                    height: 38px;
                }
            }
            .item-main{
                margin: 0 0 0 10px;
                flex: 1;
                .s1{
                    font-size: 15px;
                    font-weight: 600;
                    color: #000000;
                }
                .s2{
                    margin: 10px 0 0 0;
                    font-size: 13px;
                    color: #000000;
                }
            }
            .item-right{
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 15px;
                font-weight: 600;
                color: #FFFFFF;
                width: 80px;
                height: 30px;
                background: linear-gradient(139deg, #FF8A00 0%, #FF3B00 100%);
                border-radius: 15px;
            }
        }
        .content-item{
            position: relative;
            padding: 15px 10px 20px;
            box-sizing: border-box;
            width: 355px;
            margin: 0 auto;
            background: #FFFFFF;
            border-radius: 5px;
        }
        .content-item+.content-item{
            margin: 10px auto 0;
        }
        .content-item:last-child{
            margin: 10px auto 10px;
        }
        .content-item .title{
            font-size: 18px;
            font-weight: 600;
            color: #000000;
        }
        .open-icon-wrap{
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            overflow: hidden;
            .item{
                margin: 20px 0 0 0;
                font-size: 13px;
                color: #000000;
                width: 25%;
                text-align: center;
            }
            .item img{
                width: 45px;
            }
            .item div{
                margin: 8px 0 0 0;
            }
        }

        .ensure-title{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .s1{
                line-height: 1;
                font-size: 18px;
                font-weight: 600;
                color: #000000;
            }
            .s2{
                padding: 0 0 0 26px;
                flex: 1;
                font-size: 13px;
                color: #000000;
                background: url("~@/assets/vipGoods/opened/icon_gth.png") no-repeat 10px center/12px;
            }
            .s3{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 60px;
                height: 18px;
                border-radius: 9px;
                border: 1px solid #C8A06A;
                font-size: 13px;
                color: #C8A06A;
            }
        }
        .ensure-wrap{
            position: relative;
            padding: 17px 10px;
            box-sizing: border-box;
            margin: 15px 0 0 0;
            width: 335px;
            height: 80px;
            background: #FDF7E6;
            border: 2px solid #FFECBD;
            border-radius: 5px;
            .name{
                line-height: 1;
                font-size: 18px;
                font-weight: 600;
                color: #000000;
            }
            .info{
                margin: 5px 0 0 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
                p{
                    font-size: 13px;
                    color: #666666;
                }
                .ensure-submit{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 80px;
                    height: 24px;
                    background: linear-gradient(153deg, #FF8A00 0%, #FF3B00 100%);
                    border-radius: 12px;
                    font-size: 13px;
                    font-weight: 600;
                    color: #FFFFFF;
                }
                .record{
                    background: #FDF7E6;
                    color: #FF5E03;
                    border: 1px solid #FF5E03;
                }
            }
            &::after{
                position: absolute;
                top: -1px;
                right: -1px;
                content: ' ';
                background: url("~@/assets/vipGoods/opened/icon_wjh.png") no-repeat left/100%;
                width: 50px;
                height: 18px;
            }
        }
        .active::after{
            background: url("~@/assets/vipGoods/opened/icon_yjh.png") no-repeat left/100%;
        }
        .expire::after{
            background: url("~@/assets/vipGoods/opened/icon_ysy.png") no-repeat left/100%;
        }
        .rule-title{
            top: 0;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            width: 120px;
        }
        .rule{
            margin: 25px 0 0 0;
            font-size: 13px;
            color: #000000;
            line-height: 24px;
        }

    }
}

.footer-item-menu{
  margin: 5px 0 0 0;
  display: flex;
  justify-content: center;
  padding: 10px;
  .footer-item-menu-content{
    position: relative;
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 88px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #C0C1C4;
    text-align: center;
    line-height: 1;
    .title{
      font-size: 15px;
      line-height: 18px;
      font-weight: 600;
      color: #6A220D;
    }
    .price{
      margin: 5px 0 0 0;
      font-size: 15px;
      color: #6A220D;
    }
    .right-top-icon{
      position: absolute;
      background: #FEE068;
      border-radius: 2px 5px 2px 5px;
      font-size: 12px;
      font-weight: 600;
      color: #7F2500;
      padding: 3px 4px;
      transform-origin: 0 0;
      top: -6px;
      z-index: 99;
      right: -1px;
    }
  }
  .footer-item-menu-content+.footer-item-menu-content{
    margin: 0 0 0 5px;
  }
  .footer-item-menu-content.active{
    background: #212528;
    .title,.price{
      color: #FFFFFF;
    }
    &::after{
      content: ' ';
      position: absolute;
      right: -1px;
      bottom: -1px;
      width: 40px;
      height: 18px;
      background: url("~@/assets/vipGoods/yx2.png") no-repeat 100%/100%;
    }
    .right-top-icon{
      color: #FFFFFF;
      background: #FF5825;
    }
  }
}
.footer-img{
  font-size: 0;
  width: 375px;
  height: 230px;
  overflow: auto;
  img{
    width: 100%;
  }
}
.pay-item{
  padding: 10px 0 5px 0;
  .item{
    justify-content: center;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #000000;
    img{
      margin: 0 1px;
      width: 16px;
    }
  }
}
.pre{
  height: 68px;
}

.submit-popup{
  border-radius: 10px 10px 0 0;
  .popup-title{
    padding: 20px 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 18px;
    color: #000000;
    img{
      width: 18px;
    }
  }
}
.pay-popup{
  z-index: 999999 !important;
  border-radius: 10px 10px 0 0;
  padding: 0 0 43px 0;
  .popup-title{
    padding: 20px 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 18px;
    color: #000000;
    margin: 0 0 43px 0;
    img{
      position: absolute;
      right: 10px;
      width: 18px;
    }
  }
  .wx-item {
    padding: 0 15px;
    font-size: 15px;
    color: #000000;
    display: flex;
    align-items: center;

    &::before {
      margin: 0 10px 0 0;
      display: block;
      content: ' ';
      background: url('~@/assets/public/icon_wx01.png') no-repeat 100%/100%;
      width: 24px;
      height: 24px;
    }
  }
  .hr{
    width: 345px;
    height: 1px;
    background: #EEEEEE;
    margin: 13px auto;
  }
  .zfb-item{
    padding: 0 15px;
    font-size: 15px;
    color: #000000;
    display: flex;
    align-items: center;
    &::before{
      margin: 0 10px 0 0;
      display: block;
      content: ' ';
      background: url('~@/assets/public/icon_zfb01.png') no-repeat 100%/100%;
      width: 24px;
      height: 24px;
    }
  }
  .active::after{
    position: absolute;
    right: 15px;
    display: block;
    content: ' ';
    background: url('~@/assets/public/icon_gxzffs.png') no-repeat 100%/100%;
    width: 18px;
    height: 18px;
  }
}
.mamber-tips {
    display: flex;
    align-items: center;
    padding: 10px 10px 20px;
    .mamber-info {
        flex: 1;
        color: #666;
        font-size: 13px;
    }
}
</style>
